(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("XPReport", [], factory);
	else if(typeof exports === 'object')
		exports["XPReport"] = factory();
	else
		root["XPReport"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 